import { createSvgIcon } from "@mui/material";

/**
 * Íconos del diseño (lucide) que MUI no tiene (garantías, selección de activo). Son de trazo, así que se dibujan sin relleno y con `currentColor`
 * para tomar el color del tema igual que los de MUI.
 */
const STROKE = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;

/** `Container` de lucide: tractocamión y remolques. */
export const ContainerIcon = createSvgIcon(
  <g {...STROKE}>
    <path d="M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z" />
    <path d="M10 21.9V14L2.1 9.1" />
    <path d="m10 14 11.9-6.9" />
    <path d="M14 19.8v-8.1" />
    <path d="M18 17.5V9.4" />
  </g>,
  "Container",
);

/** `Stethoscope` de lucide: equipo médico y tecnología. */
export const StethoscopeIcon = createSvgIcon(
  <g {...STROKE}>
    <path d="M11 2v2" />
    <path d="M5 2v2" />
    <path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1" />
    <path d="M8 15a6 6 0 0 0 12 0v-3" />
    <circle cx="20" cy="10" r="2" />
  </g>,
  "Stethoscope",
);
